import { withModal } from "@/account/AccountModal";
import styled, { createGlobalStyle } from "styled-components";
import Icon from "@/atoms/Icon";
import Divider from "@/atoms/account/Divider";
import {
  FormikErrorBanner,
  FormikForm,
  FormikSubmit,
  FormikTextField,
  validateRequired,
} from "@/atoms/account/formik";
import capitalize from "lodash/capitalize";

const Title = styled.h1`
  font-size: 22px;
  line-height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #232323;
`;

const GlobalStyle = createGlobalStyle`
  .modal {
    background: #fff !important;
    width: 480px;
  }
`;

const CopyBlock = styled.div`
  color: #232323;
  font-size: 14px;
`;

const validationSchema = validateRequired(["password"]);

const ConnectAccountForm = ({ login, type, onSubmit, onSuccess }) => {
  return (
    <div>
      <Title>
        <Icon name={type.toLowerCase()} size={"1.5rem"} className={"mr-3"} />
        Connect Your Account
      </Title>
      <Divider className={"my-4"} />
      <CopyBlock>
        <p id={"password-title"} className={"font-bold"}>
          Enter your Literati Password
        </p>
        <p>
          Since it’s your first time connecting your {capitalize(type)} account
          to your Literati account, we need to confirm it’s you.
        </p>
      </CopyBlock>
      <FormikForm
        initialValues={{ login, password: "" }}
        onSubmit={onSubmit}
        className={"mt-2"}
        validationSchema={validationSchema}
        onSuccess={onSuccess}
      >
        <FormikErrorBanner />
        <FormikTextField
          label=""
          name={"password"}
          placeholder={"Enter Password"}
          aria-labelledby={"password-title"}
          type={"password"}
        />
        <FormikSubmit
          label={"Connect My Account"}
          className={"w-full"}
          allowPristine
        />
      </FormikForm>
      <GlobalStyle />
    </div>
  );
};

const ConnectAccountModal = withModal(ConnectAccountForm);

export default ConnectAccountModal;
